import { render, staticRenderFns } from "./MotionSliders.vue?vue&type=template&id=70e1c3a5&"
import script from "./MotionSliders.vue?vue&type=script&lang=js&"
export * from "./MotionSliders.vue?vue&type=script&lang=js&"
import style0 from "./MotionSliders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports